import React, { useEffect, useState } from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return 10 * 60; // Reset to 10 minutes when it reaches 0
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <Section bgColor="white" className="text-center relative overflow-hidden !bg-[#F5F0E8]" data-id="element-78">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-79">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-[#4A1D6E]/5 rounded-full blur-3xl" data-id="element-80"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-[#B8860B]/10 rounded-full blur-3xl" data-id="element-81"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10 py-12" data-id="element-82">
        <h2 className="text-4xl md:text-5xl font-serif mb-6 text-[#4A1D6E] leading-tight" data-id="element-83">
          Dejá de repetir lo mismo y empezá a entenderte de verdad.
        </h2>
        <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto font-[400] text-[#5A3D6E]" data-id="element-84">
          Accedé ahora a{' '}
          <span className="italic font-serif" data-id="element-85">Viaje a tu Interior</span> y
          comenzá tu viaje de 60 días para mirar hacia dentro, sanar patrones y
          reconectar con vos.
        </p>

        {/* Pricing & Urgency Information */}
        <div className="mt-12 flex flex-col items-center" data-id="element-86">
          {/* Pricing */}
          <div className="mb-6 text-center" data-id="element-87">
            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-88">
              <span className="text-sm text-[#8B7B8B] line-through" data-id="element-89">
                $30.000 ARS
              </span>
              <span className="text-[#8B7B8B]" data-id="element-90">→</span>
              <span className="text-3xl md:text-4xl font-serif font-bold text-[#4A1D6E]" data-id="element-91">
                $13.999 ARS
              </span>
            </div>
            <p className="text-sm font-medium text-[#5A3D6E]" data-id="element-92"></p>
          </div>

          {/* CTA Button */}
          <Button variant="primary" showIcon={false} className="!bg-[#4A1D6E] !text-[#FFF8E7] hover:!bg-[#5A2D7E] text-lg px-12 py-5 shadow-xl mb-6" data-id="element-93">
            QUIERO EMPEZAR MI VIAJE →
          </Button>

          {/* Viewing Now Badge - separate cajita */}
          <div className="w-full max-w-sm bg-[#F5F0E8] border-2 border-[#4A1D6E] rounded-xl px-5 py-3 shadow-md mb-4 animate-pulse" data-id="element-94">
            <span className="text-sm font-medium text-[#4A1D6E]" data-id="element-95">
              🔥 31 mujeres están viendo esto ahora
            </span>
          </div>

          {/* Countdown Timer - dark violet bg with golden border */}
          <div className="w-full max-w-sm bg-[#4A1D6E] rounded-xl p-5 shadow-lg border-2 border-[#B8860B]" data-id="element-96">
            <h3 className="font-serif text-lg md:text-xl mb-3 text-center text-white" data-id="element-97">
              ✨ Oferta por tiempo limitado✨
            </h3>
            <div className="flex justify-center mb-2" data-id="element-98">
              <div className="bg-black/20 rounded-lg px-6 py-3 border border-[#B8860B]/40 backdrop-blur-sm" data-id="element-99">
                <span className="text-3xl md:text-4xl font-mono font-bold text-white tracking-wider" data-id="element-100">
                  {formatTime(timeLeft)}
                </span>
              </div>
            </div>
            <p className="text-white/80 text-xs text-center mt-3" data-id="element-101">
              El precio sube cuando termine el contador
            </p>
          </div>
        </div>

        <p className="mt-8 text-sm text-[#534B53]" data-id="element-102">
          Pago seguro con Mercado Pago • Garantía de 30 días
        </p>
      </div>
    </Section>;
}